import { render, staticRenderFns } from "./PartyForm.vue?vue&type=template&id=5c8f464d"
import script from "./PartyForm.vue?vue&type=script&lang=ts"
export * from "./PartyForm.vue?vue&type=script&lang=ts"
import style0 from "./PartyForm.vue?vue&type=style&index=0&id=5c8f464d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports